import { raiseNotificationApi, revertApprovalApi } from 'Constants';
import { Context } from 'Context/Context';
import AreYouSureModal from 'Modals/AreYouSureModal';
import React, { useContext, useState } from 'react'
import { getCaseType } from 'Utils';
import { ImCross } from "react-icons/im";
import { MdDeleteOutline } from "react-icons/md";



function RevertApproval({userId,caseId, setUpdateComp, caseType, caseNumber}) {
    const [showModal, setShowModal] = useState(false);
    const {makeApiCallFunc} = useContext(Context);
    const revertApproval = (id) => {
        console.log(setUpdateComp)
        const postData = {
            caseId: caseId,
            "userId" : userId,
        }
        makeApiCallFunc(
            revertApprovalApi,
            postData,
            (data) => {
                setShowModal(false);
                const notificationObj = {
                    title : "Rescinded case approval - " + getCaseType(caseType) + " - " + caseNumber,
                    is_read : false,
                    sender: "client",
                    notificationCategory: 1,
                    caseNumber: caseNumber,
                    type: "4",
                    receiver:  userId,

                    additionalInfo: {
                        url: "/casesFeed/availableCases"
                    },
                    content: "Your approval has been rescinded by the client for the case " + getCaseType(caseType) + " - " + caseNumber + ". You may request to view this case again from the list of all cases, if you continue to remain interested in this case."
                }
                makeApiCallFunc(raiseNotificationApi, 
                    notificationObj, 
                    (data) => 
                        {
                setUpdateComp(prev => !prev)
                console.log(data)
                        },
                    (error) => console.log(error)
                    )

            },
            (data) => {
                console.log(data)
            }
        )
    }

  return (<>
            {
                showModal &&
                <AreYouSureModal
                uploadNew= {showModal}
                onClose={()=> setShowModal(false)}
                onSubmit = {revertApproval} 
                text= "Are you sure you want to remove this attorney ? This means the attorney will not see this case details anymore and also stop working on this case. This action is not reversible."
                />
            }
            <button
            type="button"
            className='flex items-center gap-1.5 rounded-lg border border-red-600 text-red-600 px-3.5 py-2 text-[13px] font-semibold hover:bg-red-50 transition-colors whitespace-nowrap'
            onClick={()=>setShowModal(true)}>
                <MdDeleteOutline size={14}/>
                Remove Approval
            </button>
        </>
  )
}

export default RevertApproval